document.addEventListener('DOMContentLoaded', function () {
  const slider = document.getElementById('mainSlider');
  if (!slider) return;

  const slides = slider.querySelectorAll('.slide');
  const dots = slider.querySelectorAll('.slider-dot');
  const prevBtn = document.getElementById('prevSlide');
  const nextBtn = document.getElementById('nextSlide');

  let currentIndex = 0;
  let autoSlideInterval = null;
  const slideDuration = 8000;

  function showSlide(index) {
    slides.forEach(s => s.classList.remove('active'));
    dots.forEach(d => d.classList.remove('active'));
    slides[index].classList.add('active');
    if (dots[index]) dots[index].classList.add('active');
    currentIndex = index;
  }

  function nextSlide() {
    showSlide((currentIndex + 1) % slides.length);
  }

  function prevSlide() {
    showSlide((currentIndex - 1 + slides.length) % slides.length);
  }

  function startAuto() {
    stopAuto();
    autoSlideInterval = setInterval(nextSlide, slideDuration);
  }

  function stopAuto() {
    if (autoSlideInterval) { clearInterval(autoSlideInterval); autoSlideInterval = null; }
  }

  if (prevBtn) prevBtn.addEventListener('click', () => { prevSlide(); startAuto(); });
  if (nextBtn) nextBtn.addEventListener('click', () => { nextSlide(); startAuto(); });

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => { showSlide(i); startAuto(); });
  });

  slider.addEventListener('mouseenter', stopAuto);
  slider.addEventListener('mouseleave', startAuto);

  showSlide(0);
  startAuto();
});
